import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatIsTnfd = () => {
  const urlConfig = {
    name: "Tnfd.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/TNFD.zip",
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="TNFD"
            title={"TNFD Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            top: "226px",
            left: "75px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#2E7D32",
              mb: 3,
              fontFamily: "DM Sans",
              fontSize: "40px",
              lineHeight: "38px",
            }}
          >
            The global standards for sustainability
            <br /> impacts
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              component="h4"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 800,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 1,
              }}
            >
              What is TNFD? — Brief introduction
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The Taskforce on Nature-related Financial Disclosures (TNFD) is an
              international initiative that provides a framework for
              organizations to identify, assess, manage, and disclose their
              nature-related risks, dependencies, and impacts.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              TNFD helps businesses and financial institutions integrate
              biodiversity and ecosystem risks into strategic decision-making
              and financial reporting, similar to how climate risks are
              addressed under the TCFD framework.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              Its goal is to ensure that companies understand how nature loss,
              ecosystem degradation, and biodiversity risks affect their
              business performance, supply chains, and financial outcomes, and
              to promote consistent, transparent, and decision-useful reporting
              to investors and stakeholders.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The TNFD framework emphasizes four key pillars:
            </Typography>
            <Box component="ul" sx={{ pl: 4, mb: 2 }}>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Governance — oversight and accountability on nature-related
                issues
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Strategy — how nature risks and opportunities are integrated
                into business plans
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Risk Management — how companies identify and manage
                nature-related risks
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                Metrics and Targets — how companies measure, monitor, and
                disclose performance on nature impacts and dependencies
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* <a
            href="https://tnfd.global/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <CustomButton title="Access Full TNFD Documentation" />
          </a> */}

          <DownloadZipButton
            config={urlConfig}
            title="Access Full TNFD Documentation"
            externalHref="https://tnfd.global/"
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatIsTnfd;
